<template>
  <div class="card">
    <div class="card-header">
      <h3 class="mb-0">Placement {{ placement.number }}</h3>
      <div class="text-right">
        <ladda-button
          v-if="!creatingProgram"
          :click="handleActivateManagers"
          class="btn btn-sm btn-outline-success"
        >
          Activate Managers
        </ladda-button>
      </div>
    </div>
    <div class="card-body" v-if="$userIsAdmin">
      <div class="row">
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">Placement Start</label>

            <div class="input-group" :class="[validationClasses('start_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="start_date"
                :config="dateConfig"
                :data-vv-scope="scope"
                data-vv-as="start date"
                v-validate="'required'"
                v-model="statePlacementStartDate"
              />
            </div><!-- /.input-group -->

            <help-block :scope="scope" field="start_date"/>
          </div><!-- /.form-group -->
        </div>
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">Placement End</label>

            <div class="input-group" :class="[validationClasses('end_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="end_date"
                :config="dateConfig"
                :data-vv-scope="scope"
                v-validate="'required'"
                data-vv-as="end date"
                v-model="statePlacementEndDate"
              />
            </div><!-- /.input-group -->

            <help-block :scope="scope" field="end_date"/>
          </div><!-- /.form-group -->
        </div>
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">Start Component Open</label>
            <div
              class="input-group"
              :class="[validationClasses('start_component_open_date', scope)]"
            >
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="start_component_open_date"
                :config="dateConfig"
                v-model="statePlacementStartComponentOpenDate"
                v-validate="'required'"
                data-vv-as="start component open date"
                :data-vv-scope="scope"
              />
            </div><!-- /.input-group -->

            <help-block :scope="scope" field="start_component_open_date"/>

            <small class="d-block mt-2" v-if="!creating">
              <strong>Open Notification:</strong>
              <br>
              <span :class="[isAfterNowClass(statePlacementStartComponentOpenDate)]">{{ isAfterNow(statePlacementStartComponentOpenDate) }}</span> {{ statePlacementStartComponentOpenDate | date }} at 10:00am
            </small>
          </div><!-- /.form-group -->
        </div>
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">Start Component Due</label>
            <div
              class="input-group"
              :class="[validationClasses('start_component_due_date', scope)]"
            >
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="start_component_due_date"
                :config="dateConfig"
                v-model="statePlacementStartComponentDueDate"
                data-vv-as="start component due date"
                v-validate="'required'"
                :data-vv-scope="scope"
              />
            </div><!-- /.input-group -->

            <help-block :scope="scope" field="start_component_due_date"/>

            <small class="d-block mt-2" v-if="!creating">
              <p class="mb-0">
                <strong>Reminder Notification:</strong>
                <br>
                <span :class="[isAfterNowClass(startComponentReminderDate)]">{{ isAfterNow(startComponentReminderDate) }}</span> {{ startComponentReminderDate | date }} at 10:00am
              </p>
              <p class="mb-0">
                <strong>Second Reminder Notification:</strong>
                <br>
                <span :class="[isAfterNowClass(startComponentReminderDateSecond)]">{{ isAfterNow(startComponentReminderDateSecond) }}</span> {{ startComponentReminderDateSecond | date }} at 10:00am
              </p>
            </small>
          </div>
          <!-- /.form-group -->
        </div>
      </div><!-- /.row -->

      <div class="row">
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">End Component Open</label>
            <div class="input-group" :class="[validationClasses('end_component_open_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="end_component_open_date"
                :config="dateConfig"
                v-model="statePlacementEndComponentOpenDate"
                v-validate="'required'"
                data-vv-as="end component open date"
                :data-vv-scope="scope"
              />
            </div>

            <help-block :scope="scope" field="end_component_open_date"/>

            <small class="d-block mt-2" v-if="!creating">
              <strong>Open Notification:</strong>
              <br>
              <span :class="[isAfterNowClass(statePlacementEndComponentOpenDate)]">{{ isAfterNow(statePlacementEndComponentOpenDate) }}</span> {{ statePlacementEndComponentOpenDate | date }} at 10:00am
            </small>
          </div><!-- /.form-group -->
        </div>
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">End Component Due</label>
            <div class="input-group" :class="[validationClasses('end_component_due_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="end_component_due_date"
                :config="dateConfig"
                v-model="statePlacementEndComponentDueDate"
                v-validate="'required'"
                data-vv-as="end component due date"
                :data-vv-scope="scope"
              />
            </div><!-- /.input-group -->

            <help-block :scope="scope" field="end_component_due_date"/>

            <small class="d-block mt-2" v-if="!creating">
              <p class="mb-0">
                <strong>Reminder Notification:</strong>
                <br>
                <span :class="[isAfterNowClass(endComponentReminderDate)]">{{ isAfterNow(endComponentReminderDate) }}</span> {{ endComponentReminderDate | date }} at 10:00am
              </p>
              <p class="mb-0">
                <strong>Second Reminder Notification:</strong>
                <br>
                <span :class="[isAfterNowClass(endComponentReminderDateSecond)]">{{ isAfterNow(endComponentReminderDateSecond) }}</span> {{ endComponentReminderDateSecond | date }} at 10:00am
              </p>
            </small>
          </div><!-- /.form-group -->
        </div>
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">Mid-Point Check-In Open</label>
            <div class="input-group" :class="[validationClasses('mid_point_checkin_open_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="mid_point_checkin_open_date"
                :config="dateConfig"
                v-model="statePlacementMidPointCheckinOpenDate"
                v-validate="'required'"
                data-vv-as="mid-point check-in open date"
                :data-vv-scope="scope"
              />
            </div>
            <help-block :scope="scope" field="mid_point_checkin_open_date"/>

            <small class="d-block mt-2" v-if="!creating">
              <strong>Open Notification:</strong>
              <br>
              <span :class="[isAfterNowClass(statePlacementMidPointCheckinOpenDate)]">{{ isAfterNow(statePlacementMidPointCheckinOpenDate) }}</span> {{ statePlacementMidPointCheckinOpenDate | date }} at 10:00am
            </small>
          </div>
        </div>
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">Mid-Point Check-In Due</label>
            <div class="input-group" :class="[validationClasses('mid_point_checkin_due_date', scope)]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="mid_point_checkin_due_date"
                :config="dateConfig"
                v-model="statePlacementMidPointCheckinDueDate"
                v-validate="'required'"
                data-vv-as="mid-point check-in due date"
                :data-vv-scope="scope"
              />
            </div>
            <help-block :scope="scope" field="mid_point_checkin_due_date"/>

            <small class="d-block mt-2" v-if="!creating">
              <strong>Due Notification:</strong>
              <br>
              <span :class="[isAfterNowClass(statePlacementMidPointCheckinDueDate)]">{{ isAfterNow(statePlacementMidPointCheckinDueDate) }}</span> {{ statePlacementMidPointCheckinDueDate | date }} at 10:00am
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body" v-else-if="$userIsCoordinator">
      <div class="row">
        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">Placement Start</label>
            <p class="form-control-plaintext minimal">
              <font-awesome :icon="['far', 'calendar-alt']"/> {{ placement.start_date | date }}
            </p>
          </div><!-- /.form-group -->
        </div>

        <div class="col-6 col-xl-3">
          <div class="form-group">
            <label class="control-label">Placement End</label>
            <p class="form-control-plaintext minimal">
              <font-awesome :icon="['far', 'calendar-alt']"/> {{ placement.end_date | date }}
            </p>
          </div><!-- /.form-group -->
        </div>
      </div><!-- /.row -->
    </div>
  </div><!-- /.card -->
</template>

<script>
import { programMethods } from 'vx/helpers'
import { stateMapper } from 'mixins/programs/placements'
import Flatpickr from 'vue-flatpickr-component'
import moment from 'moment'

export default {
  inject: ['$validator'],

  mixins: [stateMapper],

  components: {
    Flatpickr
  },

  props: {
    creating: {
      required: true,
      type: Boolean
    },
    index: {
      required: true,
      type: Number
    },
    placement: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      dateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Z'
      }
    }
  },

  computed: {
    scope () {
      return `placement-${this.index}`
    },

    startComponentReminderDate () {
      return moment(this.placement.start_component_due_date).subtract(1, 'weeks')
    },

    startComponentReminderDateSecond () {
      return moment(this.placement.start_component_due_date).add(1, 'days')
    },

    endComponentReminderDate () {
      return moment(this.placement.end_component_due_date).subtract(1, 'weeks')
    },

    endComponentReminderDateSecond () {
      return moment(this.placement.end_component_due_date).add(1, 'days')
    },

    creatingProgram () {
      return this.$route.name === 'programs.create'
    }
  },

  methods: {
    ...programMethods,

    isAfterNow (date) {
      let now = moment()

      if (now.isAfter(moment(date))) {
        return 'Sent'
      }

      return 'Scheduled'
    },

    isAfterNowClass (date) {
      let now = moment()

      if (now.isAfter(moment(date))) {
        return 'text-success'
      }

      return ''
    },

    async handleActivateManagers () {
      await this.activateManagers({
        programId: this.placement.program_id,
        placementId: this.placement.id
      })

      this.$noty.success('Managers have been activated successfully')
    }
  }
}
</script>
